import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeUtils } from '../utils/date-time.utils';

@Pipe({
  name: 'intervalToDuration'
})
export class IntervalToDurationPipe implements PipeTransform {
  transform(seconds: number): string {
    const duration = DateTimeUtils.secondsToDuration(seconds);
    const mins = `${duration.minutes}`;
    const secs = `${duration.seconds}`;
    return `${mins.padStart(2, '0')}:${secs.padStart(2, '0')}`;
  }
}
